import React, { useCallback, useEffect, useState } from "react";
import { Card, Button, Typography, Image, Row, Col, Spin } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import actions from "../redux/examdashboard/actions";
import config from "../Services/apiEndPoints";
import moment from "moment";
import dayjs from "dayjs";

const { Title, Text } = Typography;

const ExamsDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const studentId = localStorage.getItem("Student_Id");

  // Get exam details from Redux state
  const { examdashboardDetails, isFetching } = useSelector(
    (state) => state.getDetailsReducer
  );

  const getDetails = useCallback(() => {
    dispatch(
      actions.getDetails(`${config.examdashboard}?studentId=${studentId}`)
    );
  }, [dispatch, studentId]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  const handlePreviousExamDetails = () => {
    navigate("/dashboard/previousExamsList");
  };

  const handleUpcomingExamDetails = () => {
    navigate("/dashboard/enrollmentedExams");
  };

  // Static image URL
  const staticImageUrl =
    "https://media.istockphoto.com/id/1398462038/photo/online-exam-or-test.jpg?s=612x612&w=0&k=20&c=hvaH_2oA0Dm-tpQ8T5JBF_39QF3xhpic38Yi2AngaCE=";

  const examStartTime =
    examdashboardDetails?.upcoming_examination_data?.[0]?.tests
      ?.exam_start_time;

  const offline =
    examdashboardDetails?.upcoming_examination_data?.[0]?.tests?.test_type ===
    "Offline";

  // Format the date if available, fallback to "N/A"
  const formattedDate = examStartTime
    ? moment(examStartTime).format("MMMM Do YYYY, h:mm:ss A") // Example: January 6th 2025, 10:05:26 AM
    : "N/A";

  if (examdashboardDetails?.upcoming_examination_data?.[0]) {
    localStorage.setItem(
      "examId",
      examdashboardDetails?.upcoming_examination_data[0]?._id
    );
  }

  if (examdashboardDetails?.upcoming_examination_data?.[0]) {
    localStorage.setItem(
      "testId",
      examdashboardDetails?.upcoming_examination_data[0]?.tests?._id
    );
    localStorage.setItem(
      "exam_end_time",
      examdashboardDetails?.upcoming_examination_data[0]?.tests?.exam_end_time
    );
    localStorage.setItem("question_paper_id", examdashboardDetails?.upcoming_examination_data[0]?.tests?.question_paper?.question_paper_id)
  }

  return (
    <>
      <Row
        gutter={16}
        style={{
          display: "flex",
          margin: 30,
        }}
      >
        {examdashboardDetails?.previous_examination_data?.[0] && (
          <Col
            key="prev-0"
            xs={24}
            sm={12}
            md={8}
            lg={6}
            style={{ marginBottom: 30 }}
          >
            <Card
              style={{
                width: "100%",
                height: 200,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                padding: "10px",
                minWidth:200,
                minHeight:200
              }}
              cover={
                <Image
                  preview={false}
                  alt="exam-image"
                  src={staticImageUrl} // Use the static image URL
                  width="100%"
                />
              }
              actions={[
                <Button
                  type="primary"
                  icon={<FileTextOutlined />}
                  onClick={handlePreviousExamDetails}
                >
                  View Exams
                </Button>,
              ]}
            >
              <div style={{ flexGrow: 1, minHeight: 200 }}>
                <Title level={4}>Previous Exams</Title>
                <Text strong>Exam Name:</Text>{" "}
                <Text>
                  {examdashboardDetails?.previous_examination_data[0]
                    .exam_name || "N/A"}
                </Text>
                <br />
                <Text strong>Exam Description</Text>{" "}
                <Text>
                  {examdashboardDetails?.previous_examination_data[0]
                    .exam_description || "N/A"}
                </Text>
                <br />
                <Text strong>Duration:</Text>{" "}
                <Text>
                  {examdashboardDetails?.previous_examination_data?.[0]?.tests
                    ?.exam_start_time
                    ? dayjs(
                        examdashboardDetails.previous_examination_data[0].tests
                          .exam_start_time
                      ).format("DD-MM-YYYY hh:mm A")
                    : "N/A"}
                </Text>
              </div>
            </Card>
          </Col>
        )}
        {examdashboardDetails?.is_enrolled &&
          Array.isArray(examdashboardDetails?.upcoming_examination_data) &&
          examdashboardDetails.upcoming_examination_data.length > 0 && (
            <Col
              key="upcoming-0"
              xs={24}
              sm={12}
              md={8}
              lg={6}
              style={{ marginBottom: 30 }}
            >
              <Card
                style={{
                  width: "100%",
                  height: 200,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: "10px",
                  minWidth:200,
                  minHeight:200
                }}
                cover={
                  <Image
                    preview={false}
                    alt="exam-image"
                    src={staticImageUrl} // Use the static image URL
                    width="100%"
                  />
                }
                actions={[
                  !offline && (
                    <Button
                      type="primary"
                      icon={<FileTextOutlined />}
                      onClick={handleUpcomingExamDetails}
                    >
                      View Exams
                    </Button>
                  ),
                ]}
              >
                <div style={{ flexGrow: 1, minHeight: 200,minWidth:200}}>
                  <Title level={4}>Upcoming Exams</Title>
                  {offline && <Title level={5}>Offline</Title>}
                  <Text strong>Exam Name:</Text>{" "}
                  <Text>
                    {examdashboardDetails?.upcoming_examination_data[0]
                      ?.exam_name || "N/A"}
                  </Text>
                  <br />
                  <Text strong>Date:</Text>{" "}
                  <Text>{formattedDate || "N/A"}</Text>
                  <br />
                  <Text strong>Exam Description:</Text>{" "}
                  <Text>
                    {examdashboardDetails?.upcoming_examination_data[0]
                      ?.exam_description || "N/A"}
                  </Text>
                </div>
              </Card>
            </Col>
          )}
        <div>
          {examdashboardDetails?.active_examination_data?.map((exam, index) => (
            <Col
              key={`upcoming-${index}`}
              xs={24}
              sm={12}
              md={8}
              lg={6}
              style={{ marginBottom: 30 }}
            >
              <Card
                style={{
                  width: "100%",
                  height: 200,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: "10px",
                  minWidth:200,
                  minHeight:200
                }}
                cover={
                  <Image
                    preview={false}
                    alt="exam-image"
                    src={staticImageUrl} // Use the static image URL
                    width="100%"
                  />
                }
              >
                     <div style={{ flexGrow: 1, minHeight: 200 }}>
                <Title level={4}>Upcoming Exams</Title>
                <Text strong>Exam Details:</Text> <Text>{exam.exam_name}</Text>
                <br />
                <br />
                <Text strong>Exam Description:</Text>{" "}
                <Text>{exam.exam_description || "N/A"}</Text>
                </div>
              </Card>
            </Col>
          ))}
        </div>
      </Row>
    </>
  );
};

export default ExamsDetails;
